import { render } from "./bk_CS_sayhi copy.vue?vue&type=template&id=74ce3843"
import script from "./bk_CS_sayhi copy.vue?vue&type=script&lang=js"
export * from "./bk_CS_sayhi copy.vue?vue&type=script&lang=js"

import "./bk_CS_sayhi copy.vue?vue&type=style&index=0&id=74ce3843&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__